import React, {useState} from 'react';
import '../css/structure.css';
import { useTable } from "../hooks/useTable";
import { Warrantie } from '../Data/Warrantie';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Warranties () {
    const [showEditModal, setShowEditModal] = useState(false);
    const [showModal, setShowModal] = useState();
    const [selectedService, setSelectedService] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const itemsPerPage = 5;
            
    const { currentItems, filteredData, currentPage, paginate } = useTable(
        Warrantie,
        itemsPerPage,
        searchTerm
    );
        
    // Définir les en-têtes pour le PDF
    const headers = ['Nom institution', 'Adresse', 'Email', 'Téléphone','type Intitution',  'gerant', 'Poste', 'Statut'];    
        const handleAddAdmin = () => {
        alert("ok");
    };
    
    const handleAddNew = () => {
        setShowModal(true);
    };
                
    const handleCloseModal = () => {
        setShowModal(false);
    };
                
    const handleEditService = (categorie) => {
        setSelectedService(categorie);
        setShowEditModal(true);
    };
                
    const handleCloseEditModal = () => {
        setShowEditModal(false);
    };
                
    const handleUpdateService = (updatedService) => {
        const updatedList = Warrantie.map((service) => {
        if (service.nomComplet === selectedService.nomComplet) {
            return updatedService;
        }
        return service;
        });
                 
        setShowEditModal(false);
    };
    
    const handleDeleteService = (service) => {
      if (window.confirm(`Voulez-vous vraiment supprimer la service ${service.name} ?`)) {                     
         toast.success(`La service ${service.name} a été supprimé avec succès !`);
        }
      };
  return (
    <div>Warranties</div>
  )
}

export default Warranties